module.exports = __webpack_public_path__ + "static/media/header-network-kcc.0fff6da4.svg";